export const DOC_KINDS = [
  "national_id",
  "passport",
  "residence",
  "driving_license",
  "education",
  "contract",
  "health_certificate",
  "health_card",
  "police_clearance",
  "insurance",
  "other",
];
